import { BreadcrumbItem } from "Components/Breadcrumb/Breadcrumb";
import dayjs from "dayjs";
import { API_DATE_FORMAT } from "./app";

export const dashboardBreadcrumb: BreadcrumbItem[] = [
  { title: "Dashboard", link: "" },
];

export const VehicleAssignmentRangeType = [
  { label: "Year", value: "year" },
  {
    label: "Month",
    value: "month",
  },
];

export const monthCalendarTableHeads = [
  {
    id: "title",
    month: 0,
    label: "",
  },
  {
    id: "",
    label: "Jan",
    month: 1,
  },
  {
    id: "",
    label: "Feb",
    month: 2,
  },
  {
    id: "",
    label: "Mar",
    month: 3,
  },
  {
    id: "",
    label: "Apr",
    month: 4,
  },
  {
    id: "",
    label: "May",
    month: 5,
  },
  {
    id: "",
    label: "Jun",
    month: 6,
  },
  {
    id: "",
    label: "Jul",
    month: 7,
  },
  {
    id: "",
    label: "Aug",
    month: 8,
  },
  {
    id: "",
    label: "Sep",
    month: 9,
  },
  {
    id: "",
    label: "Oct",
    month: 10,
  },
  {
    id: "",
    label: "Nov",
    month: 11,
  },
  {
    id: "",
    label: "Dec",
    month: 12,
  },
];

export const getLastDayOfMonthTill30 = () => {
  const today = dayjs();

  if (today.month() !== 1) {
    return today.date(30).format(API_DATE_FORMAT);
  }

  return today.endOf("month").format(API_DATE_FORMAT);
};

export const firstDateOfCurrentMonth = dayjs()
  .startOf("month")
  .format(API_DATE_FORMAT);

export const lastDateOfCurrentMonth = getLastDayOfMonthTill30();

const currentYear = new Date().getFullYear();

export const firstDateOfCurrentYear = dayjs(new Date(currentYear, 0, 1)).format(
  API_DATE_FORMAT,
);

export const lastDateOfCurrentYear = dayjs(
  new Date(currentYear, 11, 31),
).format(API_DATE_FORMAT);
